import React, {MouseEvent, ReactNode} from "react";

import {useThemeDefaults} from "../../hooks/use_theme_defaults";
import {IComparisonTableStyleDefaults} from "../../types/IComparisonTableStyleDefaults";
import {RowHeaderIconWrap} from "./RowHeaderIcon";
import {RowHeaderTitle} from "./RowHeaderTitle";

interface IRendererProps {
    themeDefaults: IComparisonTableStyleDefaults;
}

interface IProps {
    iconSlot?: (props: IRendererProps) => ReactNode;
    labelSlot: (props: IRendererProps) => ReactNode;
    onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
    className?: string;
}

export const RowHeaderCustom = (props: IProps) => {
    const themeDefaults = useThemeDefaults();
    const {iconSlot, labelSlot, onClick, className} = props;

    return (
        <div className={className} onClick={onClick}>
            {iconSlot && <RowHeaderIconWrap iconSize={themeDefaults.headerIcons.size}>{iconSlot({themeDefaults})}</RowHeaderIconWrap>}
            <RowHeaderTitle>{labelSlot({themeDefaults})}</RowHeaderTitle>
        </div>
    );
};
import React, {MouseEvent, ReactNode} from "react";

import {useThemeDefaults} from "../../hooks/use_theme_defaults";
import {IComparisonTableStyleDefaults} from "../../types/IComparisonTableStyleDefaults";
import {RowHeaderIconWrap} from "./RowHeaderIcon";
import {RowHeaderTitle} from "./RowHeaderTitle";

interface IRendererProps {
    themeDefaults: IComparisonTableStyleDefaults;
}

interface IProps {
    iconSlot?: (props: IRendererProps) => ReactNode;
    labelSlot: (props: IRendererProps) => ReactNode;
    onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
    className?: string;
}

export const RowHeaderCustom = (props: IProps) => {
    const themeDefaults = useThemeDefaults();
    const {iconSlot, labelSlot, onClick, className} = props;

    return (
        <div className={className} onClick={onClick}>
            {iconSlot && <RowHeaderIconWrap iconSize={themeDefaults.headerIcons.size}>{iconSlot({themeDefaults})}</RowHeaderIconWrap>}
            <RowHeaderTitle>{labelSlot({themeDefaults})}</RowHeaderTitle>
        </div>
    );
};
